import { createFileRoute, useNavigate } from '@tanstack/react-router'
import SlideWizard from '@/components/learning-paths/SlideWizard'
import { pauseAndVerifyChapter } from '@/learning-paths/incode/pause-and-verify/chapter'

export const Route = createFileRoute(
  '/_auth/learning-journeys/pause-and-verify',
)({
  component: PauseAndVerifyRoute,
})

function PauseAndVerifyRoute() {
  const navigate = useNavigate()

  const handleExit = () => {
    navigate({
      to: '/learning-journeys/scam-fundamentals',
      search: { invitationcode: undefined, __clerk_ticket: undefined },
    })
  }

  return (
    <SlideWizard
      chapter={pauseAndVerifyChapter}
      onExit={handleExit}
      onComplete={handleExit}
    />
  )
}
